import { Component } from '@angular/core';
import { Home } from 'src/app/components/home/home';

@Component({
  selector: 'app-home-page',
  imports: [Home],
  templateUrl: './home-page.html',
  styleUrl: './home-page.scss',
})
export class HomePage {}
